import { Link } from "react-router-dom";
import { movies } from "@/mocks/movies";

export default function HotList() {
  const hot = [...movies].sort((a, b) => b.views - a.views).slice(0, 8);

  return (
    <div className="rounded-lg border border-background-200 bg-white p-5">
      <h2 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
        <span className="flex h-6 w-6 items-center justify-center rounded-md bg-accent-100 text-accent-600">
          <i className="ri-fire-line text-sm"></i>
        </span>
        热门影视导航
      </h2>
      <ul className="mt-3 divide-y divide-background-100">
        {hot.map((movie, i) => (
          <li key={movie.id}>
            <Link to={`/detail/${movie.id}`} className="group flex items-center gap-3 py-2.5">
              <span
                className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-md text-xs font-bold ${
                  i < 3 ? "bg-primary-500 text-background-50" : "bg-background-100 text-foreground-600"
                }`}
              >
                {i + 1}
              </span>
              <div className="h-14 w-10 shrink-0 overflow-hidden rounded-md bg-background-100">
                <img
                  src={movie.cover}
                  alt={`${movie.title} 封面`}
                  title={`${movie.title} - 热门爱情影视`}
                  className="h-full w-full object-cover object-top"
                />
              </div>
              <div className="min-w-0 flex-1">
                <p className="truncate text-sm font-medium text-foreground-950 transition-colors group-hover:text-primary-600">
                  {movie.title}
                </p>
                <p className="mt-0.5 truncate text-xs text-foreground-500">
                  {movie.type} · {movie.category}
                </p>
              </div>
              <span className="shrink-0 text-xs font-semibold text-accent-600">
                {(movie.views / 100).toFixed(1)}万
              </span>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}